import { render, staticRenderFns } from "./UsageRecipients.vue?vue&type=template&id=b411d1d2&"
import script from "./UsageRecipients.vue?vue&type=script&lang=js&"
export * from "./UsageRecipients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports